<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<div class="container-fluid" *ngIf="accessService.hasAccess([], ['enquiries.menu'])">
  <div class="row align-items-center">
    <div class="col-auto">
      <h5 class="title-secondary">
        {{ 'REQUESTS.REQUESTS_LIST.TITLE' | translate }}
      </h5>
    </div>
    <div class="col-auto ms-auto">
      <button type="button" class="btn btn-link btn-clear-filters" (click)="clearFilters()">
        {{ 'CLEAR_FILTERS' | translate }}
      </button>
    </div>
  </div>
  <kendo-grid
    [data]="data"
    [pageSize]="requestsResponse?.meta.per_page"
    [sortable]="true"
    [filterable]="true"
    [columnMenu]="true"
    [filter]="state?.filter"
    [sort]="state?.sort"
    [skip]="state?.skip"
    [pageable]="true"
    (dataStateChange)="loadData($event)"
    (columnVisibilityChange)="onVisibilityChange($event)"
    #grid
    (excelExport)="onExcelExport($event, 'Enquiries', grid)"
  >
    <kendo-grid-column
      [width]="70"
      class="text-center"
      headerClass="text-center"
      title="{{ 'REQUESTS.REQUESTS_LIST.NUMBER' | translate }}"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        {{ rowIndex + 1 }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="id"
      title="{{ 'REQUESTS.REQUESTS_LIST.ID' | translate }}"
      filter="numeric"
      [width]="150"
      [hidden]="isHiddenColumn('id', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="client.name"
      title="{{ 'REQUESTS.REQUESTS_LIST.CLIENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('client.name')"
      width="180"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-client-select [filter]="filter"></app-kendo-client-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-client-box [client]="dataItem.client"></app-client-box>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="email"
      title="{{ 'REQUESTS.REQUESTS_LIST.EMAIL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('email')"
    ></kendo-grid-column>

    <kendo-grid-column
      field="event_group.name"
      title="{{ 'REQUESTS.REQUESTS_LIST.EVENT_GROUP' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('event_group.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-group-select [filter]="filter"></app-kendo-event-group-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/event-groups/view']" [queryParams]="{ id: dataItem?.event_group?.id }" target="_blank">
          {{ dataItem?.event_group?.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="event.name"
      title="{{ 'REQUESTS.REQUESTS_LIST.EVENT' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('event.name')"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-event-select [filter]="filter"></app-kendo-event-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/events/view']" [queryParams]="{ id: dataItem?.event?.id }" target="_blank">
          {{ dataItem?.event?.formattedName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="event.city.name"
      title="{{ 'REQUESTS.REQUESTS_LIST.EVENT_CITY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('event.city.name')"
      width="100"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-city-select [filter]="filter" [field]="'event.city_id'"></app-kendo-city-select>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="company.name"
      title="{{ 'REQUESTS.REQUESTS_LIST.COMPANY' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company.name', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-company-select [filter]="filter"></app-kendo-company-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/settings/companies/view']" [queryParams]="{ id: dataItem?.company_id }" target="_blank">
          {{ dataItem?.company?.shortName }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="type"
      title="{{ 'REQUESTS.REQUESTS_LIST.TYPE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('type', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="hotel.name"
      title="{{ 'REQUESTS.REQUESTS_LIST.HOTEL' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('hotel.name', true)"
    >
      <ng-template kendoGridFilterCellTemplate let-filter>
        <app-kendo-hotel-select [filter]="filter"></app-kendo-hotel-select>
      </ng-template>

      <ng-template kendoGridCellTemplate let-dataItem>
        <a [routerLink]="['/hotels/view']" [queryParams]="{ id: dataItem?.hotel_id }" target="_blank">
          {{ dataItem?.hotel?.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="company_name"
      title="{{ 'REQUESTS.REQUESTS_LIST.COMPANY_NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company_name', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="first_name"
      title="{{ 'REQUESTS.REQUESTS_LIST.FIRST_NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('first_name', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="last_name"
      title="{{ 'REQUESTS.REQUESTS_LIST.LAST_NAME' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('last_name', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="phone"
      title="{{ 'REQUESTS.REQUESTS_LIST.PHONE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('phone', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="requirements"
      title="{{ 'REQUESTS.REQUESTS_LIST.REQUIREMENTS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('requirements', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="notes"
      title="{{ 'REQUESTS.REQUESTS_LIST.NOTES' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('notes', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="budget"
      title="{{ 'REQUESTS.REQUESTS_LIST.BUDGET' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('budget', true)"
    ></kendo-grid-column>

    <kendo-grid-column
      field="finished"
      title="{{ 'REQUESTS.REQUESTS_LIST.FINISHED' | translate }}"
      filter="boolean"
      [width]="100"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('finished')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.finished"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="sale_exist"
      title="{{ 'REQUESTS.REQUESTS_LIST.SALE_EXIST' | translate }}"
      [filterable]="false"
      [sortable]="false"
      [columnMenu]="false"
      [width]="40"
      [class]="'text-center'"
      [hidden]="isHiddenColumn('sale_exist')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <app-active-indicator [active]="dataItem.sale"></app-active-indicator>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="company_website.name"
      title="{{ 'REQUESTS.REQUESTS_LIST.COMPANY_WEBSITE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('company_website.name')"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <a *ngIf="dataItem?.company_website" [href]="'http://' + dataItem?.company_website?.name" target="_blank">
          {{ dataItem?.company_website.name }}
        </a>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="raw_data.ip_address"
      title="{{ 'REQUESTS.REQUESTS_LIST.IP_ADDRESS' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('raw_data.ip_address', true)"
      [filterable]="false"
      [sortable]="false"
    ></kendo-grid-column>

    <kendo-grid-column
      field="raw_data.user_history"
      title="{{ 'REQUESTS.REQUESTS_LIST.USER_HISTORY ' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('raw_data.user_history', true)"
      [filterable]="false"
      [sortable]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem>
        <div *ngFor="let singleUserHistory of dataItem?.raw_data?.user_history; let i = index">
          {{ singleUserHistory?.time | date : env.pipeDateTimeFormat }}: {{ singleUserHistory?.url }}
        </div>
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      field="raw_data.source"
      title="{{ 'REQUESTS.REQUESTS_LIST.SOURCE' | translate }}"
      filter="text"
      [hidden]="isHiddenColumn('raw_data.source', true)"
      [filterable]="false"
      [sortable]="false"
    ></kendo-grid-column>

    <kendo-grid-column
      [hidden]="isHiddenColumn('created_at')"
      field="created_at"
      title="{{ 'REQUESTS.REQUESTS_LIST.CREATED_AT' | translate }}"
      filter="date"
      format="{0:dd/MM/yyyy}"
      width="140"
    >
      <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
        <kendo-grid-date-filter-cell [column]="column" [filter]="filter" operator="eq"></kendo-grid-date-filter-cell>
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem>
        {{ dataItem.created_at.getDate() }}
      </ng-template>
    </kendo-grid-column>

    <kendo-grid-column
      title="{{ 'REQUESTS.REQUESTS_LIST.ACTIONS' | translate }}"
      [width]="100"
      [class]="'text-center'"
      [includeInChooser]="false"
    >
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <app-edit-button
          *ngIf="accessService.hasAccess([UserRoleType.MARKETING, UserRoleType.LEAD_GENERATION], ['enquiries.show'])"
          (click)="edit(dataItem)"
        >
        </app-edit-button>

        <app-sale-button
          *ngIf="
            accessService.hasAccess(
              [
                UserRoleType.RESERVATION_AGENT,
                UserRoleType.RESERVATION_MANAGER,
                UserRoleType.CONTRACTING_AGENT,
                UserRoleType.CONTRACTING_MANAGER,
                UserRoleType.SALES_AGENT,
                UserRoleType.SALES_MANAGER,
                UserRoleType.CUSTOMER_CARE_AGENT,
                UserRoleType.CUSTOMER_CARE_MANAGER,
                UserRoleType.FINANCE_AGENT,
                UserRoleType.FINANCE_MANAGER,
                UserRoleType.LEAD_GENERATION,
                UserRoleType.MARKETING,
                UserRoleType.EXTERNAL_PARTNER_LEAD
              ],
              ['sales.show']
            ) && dataItem.sale
          "
          [link]="['/sales/view']"
          [params]="{ id: dataItem.sale.id }"
        >
        </app-sale-button>

        <button
          *ngIf="
            accessService.hasAccess([UserRoleType.MARKETING, UserRoleType.LEAD_GENERATION], ['sales.store']) &&
            !dataItem.sale
          "
          type="button"
          (click)="createSale(dataItem)"
          class="btn btn-info btn-ico"
          [ngbTooltip]="'SALE_BUTTON.SALE' | translate"
          container="body"
        >
          <i class="fal fa-hand-holding-usd"></i>
        </button>

        <app-delete-button
          *ngIf="accessService.hasAccess([UserRoleType.MARKETING, UserRoleType.LEAD_GENERATION], ['enquiries.destroy'])"
          [swal]="{}"
          (confirm)="delete(dataItem)"
        >
        </app-delete-button>

        <app-activities-button
          *ngIf="accessService.hasAccess([UserRoleType.MARKETING, UserRoleType.LEAD_GENERATION], [])"
          [subjectType]="LaravelModels.ENQUIRY"
          [subjectId]="dataItem.id"
        >
        </app-activities-button>

        <app-user-states
          [modelType]="LaravelModels.ENQUIRY"
          [modelId]="dataItem.id"
          [countView]="true"
        ></app-user-states>
      </ng-template>
    </kendo-grid-column>

    <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
      <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
      <kendo-pager-input></kendo-pager-input>
      <kendo-pager-info></kendo-pager-info>
      <kendo-pager-next-buttons></kendo-pager-next-buttons>
      <kendo-pager-page-sizes [pageSizes]="env.kendoGridPageSizes"></kendo-pager-page-sizes>
      <app-kendo-grid-refresh-button (click)="loadData(state)"></app-kendo-grid-refresh-button>
      <button type="button" class="btn kendo-export-btn" [disabled]="grid.loading" kendoGridExcelCommand>
        {{ 'EXPORT_TO_EXCEL' | translate }}
      </button>
    </ng-template>

    <kendo-grid-excel></kendo-grid-excel>
  </kendo-grid>
</div>
